<script>
  import { account } from '../stores/core-store.js';
  import Menu from '@smui/menu';
  import List, { Item, Text } from '@smui/list';
  import { navigate } from 'svelte-routing';
  import Button, { Label, Icon } from '@smui/button';
  import { openLogoutDialog } from '../components/my-account/LogoutDialog.svelte';
  import { isUnity } from '../util/unity.js';
  import { link } from 'svelte-routing';

  let menu;
</script>

<div class="account-welcome">
  <div class="account-welcome-help">
    <a
      id="account-welcome-help"
      href="https://help.gigxr.com/knowledge/gigxr-management-system-gms"
      target="_blank"
      use:link
    >
      <img src="/icons/help-icon.svg" alt="Help Icon" />
      <span class="account-welcome-help-text">Help</span>
    </a>
  </div>
  <div>
    <Button size="small" id="account-welcome-button" on:click={() => menu.setOpen(true)} class="account-welcome-button">
      <Icon class="material-icons testtt">person</Icon>
      <Label>{$account.firstName}</Label>
    </Button>
    <Menu bind:this={menu} anchorCorner="BOTTOM_LEFT">
      <List>
        <Item id="account-welcome-my-account-link" on:SMUI:action={() => navigate('/my-account/view')}>
          <Text>My Account</Text>
        </Item>

        {#if isUnity()}
          <Item id="account-welcome-app-settings-link" on:SMUI:action={() => navigate('/app-settings')}>
            <Text>App Settings</Text>
          </Item>
        {/if}

        <Item id="account-welcome-logout-link" on:SMUI:action={() => openLogoutDialog()}>
          <Text>Logout</Text>
        </Item>
      </List>
    </Menu>
  </div>
</div>

<style>
  .account-welcome {
    display: flex;
    gap: 0.625rem;
  }

  .account-welcome-help,
  .account-welcome-help a {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .account-welcome-help-text {
    display: none;
  }

  :global(.account-welcome-button .material-icons) {
    height: 30px;
    width: 30px;
    font-size: 30px;
  }

  :global(.account-welcome-button) {
    padding: 0.5rem;
    min-width: unset;
    text-transform: none;
    white-space: nowrap;
    background: #8b8bc33b !important;
    height: unset;
    border-radius: 2rem;
  }

  :global(.account-welcome-button .mdc-button__label) {
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    display: none;
  }

  :global(.account-welcome-button .mdc-button__icon) {
    margin-right: 0rem;
    width: 1.25rem;
    height: 1.25rem;
    font-size: 1.25rem;
  }

  @media (min-width: 1100px) {
    :global(.account-welcome-button) {
      margin-right: -0.5rem;
      padding: 0.5rem 1rem;
    }

    :global(.account-welcome-button .mdc-button__icon) {
      margin-right: 0.5rem;
      width: 1.875rem;
      height: 1.875rem;
      font-size: 1.875rem;
    }

    .account-welcome-help-text {
      display: block;
    }

    .account-welcome {
      gap: 1.5rem;
    }

    :global(.account-welcome-button .mdc-button__label) {
      display: block;
    }
  }

  .account-welcome-not-you {
    margin-top: -3px;
    font-size: 13px;
  }
</style>
